import { render, staticRenderFns } from "./transfer_locations.vue.js?vue&type=template&id=5f888c15&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./transfer_locations.vue?vue&type=template&id=5f888c15&vue3"
import script from "./transfer_locations.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./transfer_locations.vue?vue&type=script&lang=js&vue3"
export * from "./transfer_locations.vue.js?vue&type=script&lang=js&vue3!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./transfer_locations.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports